import { EntityType, ErrorCodes } from "../util/UIConstants";
import { EndPoint, Environment } from "../util";

/**
 * Helps to build the url from making api calls.
 */
export class ServiceUrlHelper {
  public static herculesEndPointNamePrefix = "hercules-engid";
  public static async getClientRequestUrl(engagementId: string): Promise<string> {
    await new Promise((r) => setTimeout(r, 10));
    // todo: build the url from datacenter svc calls
    return "";
  }

  public static getClientRequestUrlFromBaseUrl(baseUrl: string, engagementId: string): string {
    return `${baseUrl}/api/engagements/${engagementId}/clientrequests/?filterType=all&quickFilter=all&includeFollowers=true&includeRequestDescription=true&includeRelatedTasks=true&includeTimephase=true&includeUserName=true&IncludePagination=false`;
  }

  public static putClientRequestUrlFromBaseUrl(baseUrl: string, engagementId: string, clientRequestId: number): string {
    return `${baseUrl}/api/engagements/${engagementId}/clientrequests/${clientRequestId}/?isBulk=true`;
  }

  public static patchDocumentUrlFromBaseUrl(baseUrl: string, engagementId: string, documentId: string): string {
    return `${baseUrl}/api/engagements/${engagementId}/documents/${documentId}/`;
  }

  public static getMasterDataEngagementTimePhasesUrlFromBaseUrl(baseUrl: string, engagementId: string): string {
    return `${baseUrl}/api/engagements/${engagementId}/TimePhases`;
  }

  public static getMasterDataContactListUrlFromBaseUrl(baseUrl: string, engagementId: string): string {
    return `${baseUrl}/api/engagements/${engagementId}/InternalUsers?UserStatus=1&IncludeRbacResult=false&IncludePagination=false`;
  }

  public static getTaskApiEndPointUrlFromBaseUrl(baseUrl: string, engagementId: string): string {
    const BasicTaskAttributes = 12;
    return `${baseUrl}/api/engagements/${engagementId}/Tasks/?categoryId=${BasicTaskAttributes}`;
  }

  public static getDocumentApiEndPointUrlFromBaseUrl(baseUrl: string, engagementId: string): string {
    return `${baseUrl}/api/engagements/${engagementId}/documents?filteredEntityType=BasicDocumentAttributes`;
  }

  public static patchDocumentApiEndPointUrlFromBaseUrl(baseUrl: string, engagementId: string): string {
    return `${baseUrl}/api/engagements/${engagementId}/Documents?isAuditLog=true`;
  }

  public static patchTaskApiEndPointUrlFromBaseUrl(baseUrl: string, engagementId: string): string {
    return `${baseUrl}/api/engagements/${engagementId}/Tasks/bulkupdates?isAuditLog=true`;
  }

  public static addClientRequestApiEndPointUrlFromBaseUrl(baseUrl: string, engagementId: string): string {
    return `${baseUrl}/api/engagements/${engagementId}/ClientRequests`;
  }

  public static addClientRequestEngagementTagsApiEndPointUrlFromBaseUrl(
    baseUrl: string,
    engagementId: string,
    tagId: string
  ): string {
    return `${baseUrl}/api/engagements/${engagementId}/tags/${tagId}/entities`;
  }

  public static addClientRequestEYContactApiEndPointUrlFromBaseUrl(
    baseUrl: string,
    engagementId: string,
    clientRequestId: string
  ): string {
    return `${baseUrl}/api/engagements/${engagementId}/ClientRequests/${clientRequestId}/Followers`;
  }

  public static deleteClientRequestEYContactApiEndPointUrlFromBaseUrl(
    baseUrl: string,
    engagementId: string,
    clientRequestId: string,
    followerId: any
  ): string {
    return `${baseUrl}/api/engagements/${engagementId}/ClientRequests/${clientRequestId}/Followers/${followerId}`;
  }

  public static getClientGroupsUrl(baseUrl: string, engagementId: string): string {
    return `${baseUrl}/api/engagements/${engagementId}/ClientGroups`;
  }

  public static getExternalUsersUrl(baseUrl: string, engagementId: string): string {
    return `${baseUrl}/api/engagements/${engagementId}/ExternalUsers?pageSize=2000`;
  }

  public static getTimePhasesUrl(baseUrl: string, engagementId: string): string {
    return `${baseUrl}/api/engagements/${engagementId}/TimePhases`;
  }

  public static getTagsUrl(baseUrl: string, engagementId: string): string {
    return `${baseUrl}/api/engagements/${engagementId}/Tags/?entityId=17&syncStatusIds=2&syncStatusIds=4&syncStatusIds=9`;
  }

  public static getInternalUsersUrl(baseUrl: string, engagementId: string): string {
    return `${baseUrl}/api/engagements/${engagementId}/InternalUsers?UserStatus=1&filterEngagementAccessType=default&IncludeRbacResult=false&IncludePagination=false`;
  }

  public static getUniversalAppHomeEndpoint(engagementId: string) {
    const endpoint = Environment.getUniversalEndPoint();
    return `${endpoint.serviceUrl}/home.json?phase=MyNavigation&Top=1&Skip=1&filters=searchtypeid eq 4,displaytypeid eq 1&SearchExpression=${engagementId}`;
  }

  public static getDocumentUrlFromBaseUrl(baseUrl: string, engagementId: string): string {
    //https://eycanvascoreapi-euw-uat3.eyua.net/api/Engagements/1598556/documents?documentCategoryName=evidence&filteredEntityType=engagement&includeReviewNotes=true&includeApprovals=true&includeFindings=true&includeClientApprovals=true&includeRelatedTasks=true&pageSize=20
    return `${baseUrl}/api/engagements/${engagementId}/documents?filteredEntityType=BasicDocumentAttributes`;
  }

  public static getTaskUrlFromBaseUrl(baseUrl: string, engagementId: string): string {
    const BasicTaskAttributes = 12;
    return `${baseUrl}/api/engagements/${engagementId}/Tasks/?categoryId=${BasicTaskAttributes}`;
  }

  public static getHerculesEndPointUri(homeJsonResponse: any): EndPoint {
    var endpoint: EndPoint = {
      name: `${ServiceUrlHelper.herculesEndPointNamePrefix}-${homeJsonResponse?.collections?.clients[0]?.collections?.workspaces[0]?.collections?.engagements[0]?.id}`,
      audienceUrl:
        homeJsonResponse?.collections?.clients[0]?.collections?.workspaces[0]?.collections?.engagements[0]?.data
          ?.herculesappaudienceuri,
      serviceUrl:
        homeJsonResponse?.collections?.clients[0]?.collections?.workspaces[0]?.collections?.engagements[0]?.data
          ?.herculesappuri,
      isldcupgraded:
        homeJsonResponse?.collections?.clients[0]?.collections?.workspaces[0]?.collections?.engagements[0]?.data
          ?.isldcupgraded,
      datacenterversion:
        homeJsonResponse?.collections?.clients[0]?.collections?.workspaces[0]?.collections?.engagements[0]?.data
          ?.datacenterversion,
      isError: false,
      ErrorCode: ErrorCodes.NoError,
    };

    if (!endpoint.audienceUrl || !endpoint.serviceUrl) {
      endpoint.ErrorCode = ErrorCodes.UniversalApiNoValidDataError;
    }

    console.log("hercules endpoint", endpoint);
    return endpoint;
  }

  // Gets the url based on selectd entity type
  public static getApiRequestUrlBasedOnEntityType(
    serviceUrl: string,
    engagementId: string,
    selectedEntityType: number
  ): string {
    switch (selectedEntityType) {
      case EntityType.Document:
        return ServiceUrlHelper.getDocumentUrlFromBaseUrl(serviceUrl, engagementId);
      case EntityType.Task:
        return ServiceUrlHelper.getTaskUrlFromBaseUrl(serviceUrl, engagementId);
      default:
        return "";
    }
  }

  public static getUniversalUserPreferenceEndpoint() {
    const endpoint = Environment.getUniversalApiEndpoint();

    return `${endpoint.serviceUrl}/users.json`;
  }

  public static getUniversalUserEngagementEndpoint() {
    const engagementStatus = "'1,7,8'";

    const endpoint = Environment.getUniversalApiEndpoint();

    return `${endpoint.serviceUrl}/engagementmetadata.json?filters=showaccessibleengagementsonly eq true, engagementstatusid eq ${engagementStatus}`;
  }
}
